import { render, staticRenderFns } from "./BouncedReportModal.vue?vue&type=template&id=dacaab18"
import script from "./BouncedReportModal.vue?vue&type=script&lang=js"
export * from "./BouncedReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports